var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { pointInMask } from '../renderers/clipUtils';
import { matrixPool } from '../utils';
/** Hit-test using spatial index candidates. */
export function hitTestSpatial(spatialIndex, worldX, worldY) {
    var e_1, _a;
    var candidates = spatialIndex.queryPoint(worldX, worldY);
    try {
        for (var candidates_1 = __values(candidates), candidates_1_1 = candidates_1.next(); !candidates_1_1.done; candidates_1_1 = candidates_1.next()) {
            var child = candidates_1_1.value;
            if (!child.visible || !child.listening)
                continue;
            var wm = child.getWorldMatrix();
            var inv = matrixPool.acquire();
            if (!wm.invertInto(inv)) {
                matrixPool.release(inv);
                continue;
            }
            var local = inv.transformPoint(worldX, worldY);
            matrixPool.release(inv);
            if (!pointInMask(child.mask, local.x, local.y))
                continue;
            if (child.containsPoint(local.x, local.y))
                return child;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (candidates_1_1 && !candidates_1_1.done && (_a = candidates_1.return)) _a.call(candidates_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
/** Recursive hit-test walking the scene tree (front-to-back). */
export function hitTestNode(group, worldX, worldY) {
    var e_2, _a;
    var children = __spreadArray([], __read(group.children), false).reverse();
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            if (!child.visible || !child.listening)
                continue;
            if ('children' in child) {
                var nested = hitTestNode(child, worldX, worldY);
                if (nested)
                    return nested;
            }
            var wm = child.getWorldMatrix();
            var inv = matrixPool.acquire();
            if (!wm.invertInto(inv)) {
                matrixPool.release(inv);
                continue;
            }
            var local = inv.transformPoint(worldX, worldY);
            matrixPool.release(inv);
            if (!pointInMask(child.mask, local.x, local.y))
                continue;
            if (child.containsPoint(local.x, local.y)) {
                return child;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return null;
}
